// @flow
import React from 'react';
import {FormattedMessage} from 'react-intl';

import LoadingPlaceholder from '../LoadingPlaceholder/LoadingPlaceholder';

type Props = {
    isBoundingBoxSearch: boolean,
    geographyName: string,
    isLoadingOrRedirecting: boolean
};

const MetaTitle = (props: Props) => {
    const {isBoundingBoxSearch, geographyName, isLoadingOrRedirecting} = props;

    if (isLoadingOrRedirecting) {
        return <LoadingPlaceholder extraClasses="MetaTitle__placeholder" />;
    }

    return (
        <div className="MetaTitle">
            {isBoundingBoxSearch && (
                <FormattedMessage
                    id="pageTitleMapArea"
                    defaultMessage="Map area"
                />
            )}
            {!isBoundingBoxSearch && geographyName}
        </div>
    );
};

MetaTitle.defaultProps = {
    isBoundingBoxSearch: false,
    geographyName: '',
    isLoadingOrRedirecting: false
};

export default MetaTitle;
